module.exports = __webpack_public_path__ + "img/bg-check-addr-mobile.a697957a.png";